import React, { Component } from 'react'
import getConfig from './config'
import Header from './Header'
import Description from './Description'
import View from '@common/NewView'

/**
 * 后续所有店铺产品宣传页转到该组件，取代
 * /localMerchant/marketingCenter/detail/${productId} 使用的组件
 */
export default class ProductIntro extends Component {
  getProductById = id => {
    return getConfig(id)
  }

  render() {
    const product = this.getProductById(this.props.id)

    return (
      <View>
        <Header product={product} renderBtn={this.props.renderBtn} />
        <Description product={product} />
      </View>
    )
  }
}
